export default __webpack_public_path__ + "static/careers-slide-1-48e721dc24fdcb7a01e663368f9e3d90.png";